import { getDefaultOptions } from './defaults'

class ENV {
  constructor(options = {}) {
    this.init(options)
  }
  /**
   * Initialize env package
   */
  init(options = {}) {
    this._options = Object.assign({}, getDefaultOptions(), options)

    return this
  }

  /**
   * Add resource
   * @param {Object} resource resource
   */
  addResource(resource) {
    this._options.resources = Object.assign({}, this._options.resources, resource)
  }

  /**
   * Set resources, clear all previews resources
   * @param {Object} resources resources
   */
  setResources(resources) {
    this._options.resources = resources
  }

  /**
   * Get all resources
   */
  getResources() {
    return this._options.resources
  }

  /**
   * Get key with namespace
   * Example: get('common:nested.key')
   * @param {String} key key
   * @param {Any} notFound not found value
   */
  get(key, notFound = null) {
    let _ns = this._options.defaultNS
    let _key = key

    const distincts = key.split(':')

    if (distincts.length > 2) {
      throw new Error('namespace separator (:) must be used only once')
    }

    if (distincts.length > 1) {
      _ns = distincts[0]
      _key = distincts[1]
    }

    const keyChains = _key.split('.')
    let _db = this._options.resources[_ns]

    if (keyChains.length < 1) {
      if (_db) return _db
      else return notFound
    }

    let value = notFound

    value = _db[keyChains[0]]

    if (value === undefined) return notFound

    for (let i = 1; i < keyChains.length; i++) {
      value = value[keyChains[i]]

      if (value === undefined) return notFound
    }

    return value
  }

  /**
   * Set default namespace
   * @param {String} namespace namespace
   */
  setDefaultNamespace(namespace) {
    this._options.defaultNS = namespace
  }
}

export default new ENV()
